import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/partners/#webpage",
   "url": "https://www.futurefamilyai.com/partners/",
   "name": "Wellness App for IVF Clinics & Agencies | FutureFamilyAI",
   "description": "Extend support beyond the appointment for IVF patients and surrogates — no fees, privacy-first, physician-connected. Request a partner pilot.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Partner Directory",
     "item": "https://www.futurefamilyai.com/partners/directory/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "For IVF Clinics & Agencies",
     "item": "https://www.futurefamilyai.com/partners/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is there a cost for clinics or agencies?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. There are no partner fees. Patients and surrogates pay no subscription fee during the pilot through December 31, 2026."
     }
    },
    {
     "@type": "Question",
     "name": "Who supports patients with setup?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "The FutureFamilyAI care team provides enrollment and device support so your staff isn't the help desk."
     }
    },
    {
     "@type": "Question",
     "name": "Can our coordinators see surrogate health data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only what the surrogate explicitly shares. Coordinators can help with logistics without access to private details."
     }
    },
    {
     "@type": "Question",
     "name": "Do we need EMR integration to participate?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Most partners begin with shared summaries."
     }
    },
    {
     "@type": "Question",
     "name": "How do patients enroll?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "You share an invitation link or code; patients enroll in minutes on iPhone or Android."
     }
    },
    {
     "@type": "Question",
     "name": "Can we be listed in the directory?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Partners receive a free listing after verification of credentials."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function PartnersPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/partners/directory">Partner Directory</Link>
              <span>›</span>
              <span>For IVF Clinics &amp; Agencies</span>
            </nav>
             <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  {/* <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span> */}
                  <h1>
                  Together, Building a More Connected Future for Families
                  </h1>
                  
                  <p className="ffh-lead speakable-content">
Partner with FutureFamilyAI to advance pregnancy wellness through connected monitoring, smarter health insights, and coordinated care. Together, we can help families, surrogates, and healthcare providers navigate every stage of the journey with greater confidence.                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Stronger Partnerships. Connected Care. Healthier Journeys.
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">Download the App </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">Explore How It Works</a>
                    </div>

                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                 <iframe width="100%" height="365" src="https://www.youtube.com/embed/gTvwrs-Cvug" title="Partner With FutureFamilyAI | Expand Support Beyond the Appointment" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI gives IVF clinics and surrogacy agencies a no-fee
                way to support patients and surrogates between visits with
                validated-cuff blood pressure, wearable trends and care-team
                review.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>IVF clinics &amp; surrogacy agencies</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Assisted reproductive technology contributes to roughly 2%
                      of U.S. births each year. (CDC ART Surveillance)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      No partner fees, ever · Surrogate-controlled privacy
                      protects your relationships · Free directory listing for
                      referrals
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">
              FOR IVF CLINICS &amp; SURROGACY AGENCIES
            </span>
            <h1>
              A Patient Wellness App for IVF Clinics and Surrogacy Agencies
            </h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI gives IVF clinics and surrogacy agencies a no-fee
              way to support patients and surrogates between visits with
              validated-cuff blood pressure, wearable trends and care-team
              review. It complements your protocols rather than replacing them,
              and surrogates control their own data. Partners also receive a
              free listing in our referral directory. Coordinators get logistics
              support without seeing private health details. Request a partner
              pilot.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Fertility clinic coordinator introducing FutureFamilyAI to a patient"
              >
                 <img
                  src="/images/fertility-clinic.jpg"
                  alt=" Fertility clinic coordinator introducing FutureFamilyAI to a patient" />
              
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Assisted reproductive technology contributes to roughly 2%
                    of U.S. births each year.
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/art/">
                        CDC ART Surveillance
                      </a>
                    </cite>
                  </li>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What your patients and surrogates get</h2>
                <ul>
                  <li>A simple daily routine with a clear status.</li>
                  <li>Care-team review at Orange and Red.</li>
                  <li>
                    Monitoring that continues through pregnancy and postpartum.
                  </li>
                  <li>
                    No subscription fee during the pilot through December 31,
                    2026.
                  </li>
                </ul>
              </section>
              <section id="s2">
                <h2>What your team gets</h2>
                <ul>
                  <li>
                    Optional logistics support for coordinators — without access
                    to private health details unless shared.
                  </li>
                  <li>Fewer status-check calls from intended parents.</li>
                  <li>Patient education materials co-branded on request.</li>
                  <li>
                    A free listing in the FutureFamilyAI Partner Directory.
                  </li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
              <section id="s3">
                <h2>What we will never claim</h2>
                <p>
                  FutureFamilyAI does not improve IVF success rates or replace
                  your clinical protocol. We make that clear to your patients,
                  too.
                </p>
              </section>
              <section id="s4">
                <h2>Start with a pilot</h2>
                <p>
                  Choose a cohort, we handle onboarding and device guidance, and
                  you review the experience with us at 90 days.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Is there a cost for clinics or agencies?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        No. There are no partner fees. Patients and surrogates
                        pay no subscription fee during the pilot through
                        December 31, 2026.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Who supports patients with setup?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        The FutureFamilyAI care team provides enrollment and
                        device support so your staff isn&apos;t the help desk.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can our coordinators see surrogate health data?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Only what the surrogate explicitly shares. Coordinators
                        can help with logistics without access to private
                        details.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Do we need EMR integration to participate?
                    </summary>
                    <div className="ffh-ans">
                      <p>No. Most partners begin with shared summaries.</p>
                    </div>
                  </details>
                  <details>
                    <summary>How do patients enroll?</summary>
                    <div className="ffh-ans">
                      <p>
                        You share an invitation link or code; patients enroll in
                        minutes on iPhone or Android.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we be listed in the directory?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes. Partners receive a free listing after verification
                        of credentials.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/partners/directory">Partner Directory →</Link>
                  <Link to="/partners/join-referral-network">
                    Join Referral Network →
                  </Link>
                  <Link to="/partners/ivf-clinic-partnership">
                    IVF Clinic Partnership →
                  </Link>
                  <Link to="/partners/surrogacy-agency-partnership">
                    Surrogacy Agency Partnership →
                  </Link>
                  <Link to="/partners/no-fee-directory-faq">
                    No-Fee Directory FAQ →
                  </Link>
                  <Link to="/partners/find-a-provider">Find a Provider →</Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What your patients and surrogates get</a>
                  </li>
                  <li>
                    <a href="#s2">What your team gets</a>
                  </li>
                  <li>
                    <a href="#s3">What we will never claim</a>
                  </li>
                  <li>
                    <a href="#s4">Start with a pilot</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
